import React from "react";
import '../../sass/components/flexibleModules/_components.featuredSectionModule.scss';
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const FeaturedSectionModule = ({ data }) => {

    const scrollToSection = () => {
        if (document.querySelector(".cp-heroSectionWithFormAndThumbnail")) {
            window.scrollTo({
                top: document.querySelector(".cp-heroSectionWithFormAndThumbnail").offsetTop - 10,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    return (
        <div className="cp-featuredSectionModule" style={{ backgroundColor: `${data.backgroundColor ? data.backgroundColor : ""}` }}>
            <div className="cp-featuredSectionModule__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.featuredSectionMainHeader &&
                    <h2>{data.featuredSectionMainHeader}</h2>
                }
                {data.featuredSectionMainTeaser &&
                    <div dangerouslySetInnerHTML={{ __html: data.featuredSectionMainTeaser }} />
                }
                <div className={`cp-featuredSectionModule__section l-layout${data.featuredSectionLayout}`}>
                    <div className="cp-featuredSectionModule__section-inner l--flex">
                        <div className="cp-featuredSectionModule__section-left">
                            {data.featuredSectionSubHeader &&
                                <h4 dangerouslySetInnerHTML={{ __html: data.featuredSectionSubHeader }} />
                            }
                            {data.featuredSectionHeader &&
                                <h3>{data.featuredSectionHeader}</h3>
                            }
                            {data.featuredSectionTeaser &&
                                <p>{data.featuredSectionTeaser}</p>
                            }
                            {data.featuredSectionButton &&
                                <>
                                    {data.featuredSectionButton.url === '#form' ?
                                        <button onClick={scrollToSection} className="l-button" dangerouslySetInnerHTML={{__html: data.featuredSectionButton.title}} />
                                        :
                                        <a href={data.featuredSectionButton.url} target={data.featuredSectionButton.target} className="l-button" dangerouslySetInnerHTML={{__html: data.featuredSectionButton.title}} />
                                    }
                                </>
                            }
                        </div>
                        <div className="cp-featuredSectionModule__section-right">
                            {data.featuredSectionImage &&
                                <GatsbyImage image={getImage(data.featuredSectionImage.gatsbyImage)} alt={data.featuredSectionImage.altText} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FeaturedSectionModule;